import { ApiServiceCollection } from "../ApiServiceCollection.class";
import { ApiServiceEndpoint } from "../api.types";
import { ApiResponse } from "../RequestManager.class";

export class AccessService extends ApiServiceCollection {
    verifyAccess: ApiServiceEndpoint<void> = () => {
        return this.standardAuthRequest(`${process.env.REACT_APP_MANAGEMENT_API_URL as string}/admin/verify-access`, {
            method: 'GET',
            headers: {
                ...this.getJSONHeaders()
            },
        }, {
            mock: this.mocked,
            getMockStatus: () => this.getNextMockStatus('AccessService.verifyAccess'),
            transformResponsePayload: async (apiResponse: ApiResponse) => ({
                response: apiResponse.response,
                success: true,
                jsonBody: undefined
            })
        })
            .catch(error => error);
    };
}
